import { Input, Label } from 'reactstrap'
import { CategoriesLearning } from '../../../../../Utils/Constants'
import { learningFilterData } from '../../../../../Data/Learning/Learning'

const CategoriesCheckBox = () => {
  return (
    <div className="checkbox-animated">
      <div className="learning-header">
        <span className="f-w-700">{CategoriesLearning}</span>
      </div>
      {learningFilterData.map((data, index) => (
        <Label key={index} className="d-block mb-2" htmlFor={`chk-ani-${index}`}>
          <Input className="checkbox_animated" id={`chk-ani-${index}`} type="checkbox" />{data}</Label>
      ))}
    </div>
  )
}

export default CategoriesCheckBox